import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ContentHeader, ContentNav } from 'src/components'

class ContractsNavigation extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    static NAV_ITEMS = [
        {
            name: 'Overview',
            link: 'contracts-overview',
        },
    ]

    render() {
        const { title } = this.props

        return (
            <ContentHeader>
                <ContentNav
                    title={title}
                    contentNavItems={ContractsNavigation.NAV_ITEMS}
                >
                    {this.props.children}
                </ContentNav>
            </ContentHeader>
        )
    }
}

export default ContractsNavigation
